export default __webpack_public_path__ + "static/media/Foto-09.21e9a89c.png";